import React, { useEffect, useState } from "react";
import { Plus } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { PageHeader, Card, Badge, Loading, Modal } from "../components/ui";

const COLS = [["TODO", "To Do"], ["IN_PROGRESS", "In Progress"], ["DONE", "Done"]];

export default function Tasks() {
  const { meta } = useAuth();
  const [tasks, setTasks] = useState(null);
  const [emps, setEmps] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ title: "", description: "", assignedToId: "", priority: "MEDIUM" });

  const load = () => api.get("/tasks").then(({ data }) => setTasks(data));
  useEffect(() => { load(); api.get("/employees?limit=100").then(({ data }) => setEmps(data.items)); }, []);
  const create = async (e) => { e.preventDefault(); await api.post("/tasks", form); setOpen(false); setForm({ title: "", description: "", assignedToId: "", priority: "MEDIUM" }); load(); };
  const move = async (t, status) => { await api.put(`/tasks/${t.id}`, { status }); load(); };
  if (!tasks) return <Loading />;

  return (
    <div>
      <PageHeader title="Tasks" subtitle="Team kanban board">
        <button data-testid="add-task" onClick={() => setOpen(true)} className="btn-accent"><Plus size={16} /> New Task</button>
      </PageHeader>
      <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
        {COLS.map(([key, label]) => {
          const col = tasks.filter((t) => t.status === key);
          return (
            <div key={key} data-testid={`column-${key}`}>
              <div className="mb-3 flex items-center justify-between">
                <h3 className="font-head text-sm font-bold uppercase tracking-wide text-slate-500 dark:text-slate-400">{label}</h3>
                <span className="rounded-full bg-slate-100 px-2 py-0.5 text-xs font-semibold text-slate-500 dark:bg-slate-800">{col.length}</span>
              </div>
              <div className="space-y-3">
                {col.map((t) => (
                  <Card key={t.id} className="p-4" data-testid={`task-${t.id}`}>
                    <div className="mb-2 flex items-start justify-between gap-2">
                      <p className="text-sm font-semibold text-slate-800 dark:text-slate-100">{t.title}</p>
                      <Badge value={t.priority} />
                    </div>
                    {t.description && <p className="mb-3 text-xs text-slate-500 dark:text-slate-400">{t.description}</p>}
                    <div className="flex items-center justify-between">
                      <span className="text-xs text-slate-400">{t.assignedToName}</span>
                      <select value={t.status} onChange={(e) => move(t, e.target.value)} className="rounded border border-slate-200 bg-transparent px-1.5 py-1 text-xs dark:border-slate-700" data-testid={`move-${t.id}`}>
                        {COLS.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
                      </select>
                    </div>
                  </Card>
                ))}
              </div>
            </div>
          );
        })}
      </div>
      <Modal open={open} onClose={() => setOpen(false)} title="New Task"
        footer={<><button onClick={() => setOpen(false)} className="btn-outline">Cancel</button><button form="task-form" className="btn-accent">Create</button></>}>
        <form id="task-form" onSubmit={create} className="space-y-4">
          <div><label className="label">Title *</label><input required data-testid="task-title" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} className="input" /></div>
          <div><label className="label">Description</label><textarea data-testid="task-desc" value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} className="input h-20 py-2" /></div>
          <div className="grid grid-cols-2 gap-4">
            <div><label className="label">Assign To *</label>
              <select required data-testid="task-assignee" value={form.assignedToId} onChange={(e) => setForm({ ...form, assignedToId: e.target.value })} className="input">
                <option value="">— Select —</option>
                {emps.map((e) => <option key={e.id} value={e.id}>{e.fullName}</option>)}
              </select></div>
            <div><label className="label">Priority</label>
              <select value={form.priority} onChange={(e) => setForm({ ...form, priority: e.target.value })} className="input">
                {["LOW", "MEDIUM", "HIGH"].map((p) => <option key={p}>{p}</option>)}
              </select></div>
          </div>
        </form>
      </Modal>
    </div>
  );
}
